import { forceStoneShardsColumn } from "../resource/force-stone-shards-column";
import { NeededColumn } from "./needed-column";

export const forceStoneShardNeededColumn = new NeededColumn(
  "4f41cbdc-fab9-4f83-9853-520ef190c78f",
  forceStoneShardsColumn,
  "Force Stone Shard Needed"
)
